export default "__VITE_ASSET__zq_XA4m2__"